import React from 'react'

const Social = () => {
    return(
        <ul className="social-links">
            <li>
                <a href="http://www.facebook.com"><i>&#xf09a;</i></a>
            </li>
            {/*<li>*/}
                {/*<a href="www.facebook.com"><i>&#xf099;</i></a>*/}
            {/*</li>*/}
            <li>
                <a href="www.facebook.com"><i>&#xf16d;</i></a>
            </li>
        </ul>
    )
}

export default Social


// WEBPACK FOOTER //
// ./src/components/common/Social/Social.js